import React from "react";
import CounterCard from "./CounterCard";
const countValue = [
    {count:"20",text:"মোট রিভাইভ টেস্ট",time:"15"},
    {count:"22",text:"OBE সেমিনার ও ওয়ার্কশপ ",time:"15"},
    {count:"2",text:"ফ্র্যাঞ্চাইজি স্কুল",time:"15"},
]
const Counter = () => {
  return (
    <div className="w-full bg-[#101E2B] flex justify-center items-center sm:py-[7rem] py-[4rem]">
      <div className="container flex flex-col items-center justify-center gap-4 px-4 sm:px-0">
        <h1 className="sm:text-4xl text-3xl font-bold text-white text-center ">
          স্কুল, কলেজ ও বিশ্ববিদ্যালয় পর্যায়ের শিক্ষায় QS Academy এর সাফল্য
        </h1>
        <p className="text-white text-center text-xl">
          তোমাদের সাফল্যই আমাদের অনুপ্রেরণা
        </p>

        <div className="sm:mt-[5rem] mt-[3rem] grid sm:grid-cols-3 grid-cols-2 gap-8">
            {countValue.map((items,index)=>(
                <CounterCard key={index} value={items}/>
            ))}
            
          
        </div>
      </div>
    </div>
  );
};

export default Counter;
